<template>
  <div class="this-skills page">
    <h1 class="title page-title">{{ $t('skills.title') }}</h1>

    <div class="skill-cat">
      <h2>{{ $t('skills.knowledge.title') }}</h2>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.agile') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.spec') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.conception') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.dev') }}</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.integration') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.optimisation') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.webapp') }}</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.hybridMobile') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.improvement') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.debug') }}</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">{{ $t('skills.knowledge.prototyping') }}</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>
    </div>

    <div class="skill-cat">
      <h2>{{ $t('skills.languages.title') }}</h2>

      <div class="skill-panel">
        <span class="skill front">Javascript</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">Java</span>

        <div class="skill back">
          <SkillRating rate="2"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">C#</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>
    </div>

    <div class="skill-cat">
      <h2>{{ $t('skills.framework.title') }}</h2>

      <div class="skill-panel">
        <span class="skill front">VueJs</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">NodeJs</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">NativeScript</span>

        <div class="skill back">
          <SkillRating rate="2"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">Angular</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">.Net Framework</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>
    </div>

    <div class="skill-cat">
      <h2>{{ $t('skills.os.title') }}</h2>

      <div class="skill-panel">
        <span class="skill front">Linux</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">Windows</span>

        <div class="skill back">
          <SkillRating rate="3"></SkillRating>
        </div>
      </div>
    </div>

    <div class="skill-cat">
      <h2>{{ $t('skills.browser.title') }}</h2>

      <div class="skill-panel">
        <span class="skill front">Firefox</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">Chrome</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">Opera</span>

        <div class="skill back">
          <SkillRating rate="4"></SkillRating>
        </div>
      </div>

      <div class="skill-panel">
        <span class="skill front">Edge</span>

        <div class="skill back">
          <SkillRating rate="2"></SkillRating>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkillRating from "../components/skillRating";
export default {
  name: 'Skills',
  components: {SkillRating},
  props: {},
  mounted() {
    this.fitSkillPanelToContent();
  },
  methods: {
    fitSkillPanelToContent: function () {
      const minWidth = 110;
      document.getElementsByClassName('skill-panel').forEach(elt => {
        let front;
        elt.children.forEach(child => {
          if (child.className && child.className.indexOf('front') > -1) {
            front = child;
          }
        });
        if (front !== undefined) {
          elt.style.height = front.offsetHeight + 'px';
          if (front.offsetWidth < minWidth) {
            elt.style.width = minWidth + 'px';
          } else {
            elt.style.width = front.offsetWidth + 'px';
          }
          front.style.width = '100%';
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-skills {
    background-color: $mainColor;

    .title {
      text-align: center;
    }

    .skill-cat {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      h2 {
        color: $secondaryColor;
        text-align: center;
        width: 100%;
        margin-top: 40px;
        margin-bottom: 20px;
      }

      .skill-panel {
        position: relative;
        margin: 5px 20px;
        background-color: #88f3ff;
        overflow: hidden;
        .skill {
          text-transform: uppercase;
          border: 2px solid $white;
          position: absolute;
          top: 0;
          left: 0;
          overflow: hidden;
          transition: .5s ease;
        }

        .front {
          color: $white;
          background-color: $mainColor;
          padding: 10px 20px;
          /*width: 100%;*/
          text-align: center;
        }

        .back {
          color: $secondaryColor;
          background-color: $white;
          transform: translateX(150%);
          padding: 10px 5px;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .skill-panel:hover {
        .back {
          transform: translateX(0);
        }
        .front {
          transform: translateX(-150%);
        }
      }
    }
  }
</style>
